import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AdminTimelyResponseBanner } from 'src/modules/admin/components/AdminTimelyResponseBanner';

import { TimelyResponseBanner } from 'src/modules/dashboard/components/TimelyResponseBanner';
import { VerifyEmailAddressBanner } from 'src/modules/dashboard/components/VerifyEmailAddressBanner';
import { getUserUnconfirmedEmail } from 'src/modules/user/selectors/userSelectors';

import { useLocalizedVersion } from '../hooks/useLocalizedVersion';
import { Header } from './Header';
import * as S from './styles';

const Banners = () => {
    const location = useLocation();
    const userUnconfirmedEmail = useSelector(getUserUnconfirmedEmail);
    const { showTimelyResponseBanner, showAdminTimelyResponseBanner } = useFlags();
    const [localizedVersion] = useLocalizedVersion();

    const shouldShowVerifyEmailAddressBanner =
        location.pathname.includes('/dashboard') &&
        userUnconfirmedEmail !== '' &&
        userUnconfirmedEmail != null;

    const shouldShowTimelyResponseBanner =
        location.pathname.includes('/dashboard') && showTimelyResponseBanner && !localizedVersion;
    const shouldShowAdminTimelyResponseBanner =
        location.pathname === '/admin' && showAdminTimelyResponseBanner && !localizedVersion;

    if (shouldShowVerifyEmailAddressBanner) {
        return <VerifyEmailAddressBanner />;
    }

    if (shouldShowAdminTimelyResponseBanner) {
        return <AdminTimelyResponseBanner />;
    }

    if (shouldShowTimelyResponseBanner) {
        return <TimelyResponseBanner />;
    }

    return null;
};

/**
 * This layout is used for authenticated pages, it shows our navigation,
 * popup banner, and branding.
 */
export const AuthenticatedLayout: React.FC = ({ children }) => {
    return (
        <>
            <Banners />
            <Header />
            <S.Content data-testid="appContent">{children}</S.Content>
        </>
    );
};
